export const environment = {
  production: false,
  apiURL: 'https://apidona.pmi.or.id/api',
  imageURL: 'https://apidona.pmi.or.id/api/images',
  //apiURL: 'http://localhost:8080/api',
  //imageURL: 'http://localhost:8080/api/images',
  apiEmail :'http://localhost:6969'
};
